<template>
  <InteractionStep
                   :disabled-next="false"
                   :pending-next="pendingSave"
                   @next="onSave">
    <template v-slot:content>
      <div class="step-check-list">
        <div v-if="address"
             class="step-check-list__item">
          <span class="step-check-list__name">{{ $tInteraction('Address') }}</span>
          <button type="button"
                  class="step-check-list__val-copy base-btn base-btn--blue-dark d-none d-sm-inline-flex"
                  @click.prevent="onCopy(address)">
            <BaseSvg name="ico-copy"
                     width="1.2rem"
                     height="1.3rem"
                     style="margin-right: 0"/>
            <span class="small-tooltip" :class="{'_show': addressCopyTooltip}">
              <BaseSvg name="ico-check"/>
              <span>{{ $tGlobal('Copied') }}</span>
            </span>
          </button>
          <div class="step-check-list__val-wrap">
            <span class="step-check-list__val">{{address}}</span>
            <button type="button"
                    class="step-check-list__val-copy base-btn base-btn--blue-dark d-sm-none"
                    @click.prevent="onCopy(address)">
              <BaseSvg name="ico-copy"
                       width="1.2rem"
                       height="1.3rem"
                       style="margin-right: 0"/>
              <span class="small-tooltip" :class="{'_show': addressCopyTooltip}">
                <BaseSvg name="ico-check"/>
                <span>{{ $tGlobal('Copied') }}</span>
              </span>
            </button>
          </div>
        </div>
        <div v-if="dataTimeString"
             class="step-check-list__item">
          <span class="step-check-list__name">{{ $tInteraction('Arrival time')}}:</span>
          <div class="step-check-list__val-wrap"><span class="step-check-list__val">{{dataTimeString}}</span>
          </div>
        </div>
        <div v-if="data.transfer"
             class="step-check-list__item">
          <span class="step-check-list__name">{{ $tInteraction('With a transfer') }}:</span>
          <div class="step-check-list__val-wrap"><span class="step-check-list__val">{{data.transfer === 1 ? $tInteraction('Yes') : $tInteraction('No')}}</span></div>
        </div>
      </div>
      <BaseAlert :value="error"
                 class="step-contract__error  _error"/>
    </template>
  </InteractionStep>
</template>

<script>
  import {http} from '../../../axios'
  import InteractionStep from '../InteractionStep'
  import parseDateForLocal from '../../../helpers/parseDateForLocal'
  import interactionStepMixin from "@/mixins/interactionStepMixin"

  let timerCopy

  export default {
    name: 'InteractionStepPassport2',
    mixins: [interactionStepMixin],
    data() {
      return {
        pendingSave: false,
        error: null,
        data: null,
        addressCopyTooltip: false
      }
    },
    components: {
      InteractionStep
    },
    computed: {
      dataTimeString() {
        const d = parseDateForLocal(this.data.data)
        // d.setHours(this.data.time_hours)
        // d.setMinutes(this.data.time_minutes)
        return d.toLocaleString([], { hour: '2-digit', minute: '2-digit' ,  year: 'numeric', month: 'numeric', day: 'numeric' })
      },
      address() {
        const a = [this.data.city, this.data.street_name, this.data.street_number]
        return a.filter(a => a).join(', ')
      }
    },
    methods: {
      onSave() {
        this.error = null
        this.pendingSave = true

        const step = this.$store.state.interaction.step

        http.post(`/api/new-interaction/${this.$route.params.id}/${step}`).then(async () => {
          await this.$store.dispatch('interaction/loadInteraction')
        }).catch(e => {
          this.handleInteractionError(e)
        }).finally(() => {
          this.pendingSave = false
        })
      },
      onCopy(text) {
        navigator.clipboard.writeText(text)
        this.addressCopyTooltip = true

        clearTimeout(timerCopy)
        timerCopy = setTimeout(() => {
          this.addressCopyTooltip = false
        }, 2500)
      },
    },
    created() {
      this.data = this.$store.state.interaction.stepData.data
    }
  }
</script>

<style>

</style>
